export default __webpack_public_path__ + "static/brand-image-a080a528396b088c2b1f1dad3ae7a8f2.jpg";